export default "<div class=\"lib-alert-container\"></div>\n";